const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const EnragedCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.duration = duration;
	condition.handle = 'enraged';

	const extant = BattleCalc.getCondition( owner, 'enraged' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = EnragedCondition
